import { useTranslation } from 'react-i18next';
import { directionOf } from './i18n';

export interface I18nTranslation {
  t: ReturnType<typeof useTranslation>['t'];
  language: string;
  direction: 'ltr' | 'rtl';
  isRtl: boolean;
}

/** The single translation hook the app uses, so swapping i18n libraries touches one file. */
export const useI18nTranslation = (): I18nTranslation => {
  const { t, i18n } = useTranslation();
  const direction = directionOf(i18n.language);

  return {
    t,
    language: i18n.language,
    direction,
    isRtl: direction === 'rtl',
  };
};
